import type { IProperty } from 'src/services/api/properties/types';

/**
 * Resolve a property to its building root: the parent when it is a leaf,
 * otherwise the property itself. Scheduling always happens at the building
 * level, so a leaf property scopes up to its parent.
 */
export function resolveRootId(properties: IProperty[], propertyId: number | null): number | null {
    if (propertyId == null) {
        return null;
    }
    const property = properties.find((p) => p?.id === propertyId);
    return property?.parent_property_id ?? propertyId;
}

/**
 * The building family for a root: the root plus all its direct children, so
 * selecting a parent scopes to every leaf unit in the building.
 */
export function collectFamilyPropertyIds(properties: IProperty[], rootId: number | null): Set<number> {
    const ids = new Set<number>();
    if (rootId != null) {
        ids.add(rootId);
        properties.forEach((property) => {
            if (property?.parent_property_id === rootId) {
                ids.add(property.id);
            }
        });
    }
    return ids;
}
